module.exports = __webpack_public_path__ + "img/cupones.3ce3a025.svg";